import { z } from "zod";
import {
  DTOElementPropertyDefinitionCreatePayload,
  DTOElementPropertyDefinitionListResponse,
  DTOElementPropertyDefinitionResponse,
  DTOElementPropertyDefinitionUpdatePayload,
} from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class ElementPropertyDefinitionsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(designSystemId: string, versionId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/definitions`,
      DTOElementPropertyDefinitionListResponse
    );
  }

  create(designSystemId: string, versionId: string, body: DTOElementPropertyDefinitionCreatePayload) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/definitions`,
      DTOElementPropertyDefinitionResponse,
      { method: "POST", body }
    );
  }

  update(designSystemId: string, versionId: string, defId: string, body: DTOElementPropertyDefinitionUpdatePayload) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/definitions/${defId}`,
      DTOElementPropertyDefinitionResponse,
      { method: "PUT", body }
    );
  }

  delete(designSystemId: string, versionId: string, defId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/definitions/${defId}`,
      z.any(),
      { method: "DELETE" }
    );
  }
}
